export default __webpack_public_path__ + "static/media/best_wallet_logo.2c10890a.svg";